<script setup lang="ts">
import { useTranslate } from "@/composables/useTranslate";
import { InstallationTermin } from "@/types";
import { getTerminStatusColor } from "@/utils/status-color";
import { defineProps } from "vue";

const { t } = useTranslate();

defineProps<Props>();
type Props = {
  termins?: InstallationTermin[];
};
</script>

<template>
  <!-- Header -->
  <div
    class="w-full min-h-[41px] px-2 rounded-primary-radius bg-[#E5E4E2] grid grid-cols-5 gap-3 lg:gap-0 items-center"
  >
    <div class="flex items-center">
      <span
        class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
        >{{ t("installers.table_column_name") }}</span
      >
    </div>
    <div class="flex items-center">
      <span
        class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
        >{{ t("installers.table_column_status") }}</span
      >
    </div>
    <div class="flex items-center">
      <span
        class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
        >QC Status</span
      >
    </div>
    <div class="flex items-center">
      <span
        class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
        >{{ t("installers.table_column_date") }}</span
      >
    </div>
    <div class="flex items-center">
      <span
        class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
        >{{ t("installers.table_column_teammates") }}</span
      >
    </div>
  </div>
  <!-- Content -->
  <div
    class="w-full h-[440px] 2xl:h-[640px] overflow-y-scroll flex flex-col gap-2"
  >
    <div
      v-for="(appointment, index) in termins"
      :key="appointment.id"
      class="w-full rounded-primary-radius py-3 px-2 bg-white grid grid-cols-5 gap-3 lg:gap-0 items-center"
      :class="index === 0 ? 'mt-3' : 'mt-0'"
    >
      <div class="flex items-center">
        <span
          class="text-primary-text-color text-sm font-normal leading-[20px] break-all"
          >{{ appointment.name ? appointment.name : "-" }}</span
        >
      </div>
      <div class="flex items-center pr-2">
        <span
          class="text-[#393840] px-[6px] py-[2px] rounded-primary-radius text-xs font-medium tracking-[0.01rem]"
          :style="`background: ${getTerminStatusColor(appointment.status?.id)}`"
          >{{
            appointment.status?.name
              ? appointment.status?.name.charAt(0).toUpperCase() +
                appointment.status?.name.slice(1)
              : "-"
          }}</span
        >
      </div>
      <div class="flex items-center pr-2">
        <span
          class="text-primary-text-color px-[6px] py-[2px] rounded-primary-radius text-sm font-medium tracking-[0.01rem]"
          :style="`background-color: #FCD3AC`"
          >{{ appointment.qc_status ? appointment.qc_status.name : "-" }}</span
        >
      </div>
      <div
        class="flex flex-col items-start custom-lg:flex-row custom-lg:items-center gap-1"
      >
        <span
          class="text-primary-text-color text-sm font-normal leading-[20px]"
          >{{
            appointment.start
              ? new Date(appointment.start).toLocaleDateString("DE")
              : "-"
          }}</span
        >
        <span class="text-primary-text-color text-sm font-normal leading-[20px]"
          >-</span
        >
        <span
          class="text-primary-text-color text-sm font-normal leading-[20px]"
          >{{
            appointment.end
              ? new Date(appointment.end).toLocaleDateString("DE")
              : "-"
          }}</span
        >
      </div>
      <div class="flex flex-wrap items-center gap-1">
        <span
          class="text-primary-text-color text-sm font-normal break-all"
          v-for="(worker, index) in appointment.workers"
          :key="index"
        >
          {{ worker.name }}
        </span>
      </div>
    </div>
  </div>
</template>
